// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.survey-form-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px;
}
.survey-form-wrapper .survey-form-container {
  margin: 0 auto;
  max-width: 570px;
  width: 100%;
  background: white;
  padding: 40px;
}
.survey-form-wrapper .survey-form-container .survey-form-title {
  font-size: 16px;
  font-weight: 500;
  margin: 0 0 20px 0;
}
.survey-form-wrapper .survey-form-container .survey-form-description {
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-size: 14px;
  margin: 0 0 40px 0;
  white-space: break-spaces;
  font-weight: 400;
  line-height: 14px;
  font-style: italic;
  color: #3a3f52;
}
.survey-form-wrapper .survey-form-container .survey-form-section {
  margin-bottom: 18px;
}
.survey-form-wrapper .survey-form-container .survey-form-section .survey-form-section-label {
  color: #000000;
  font-size: 14px;
  line-height: 24px;
  display: block;
  margin-bottom: 10px;
}
.survey-form-wrapper .survey-form-container .survey-form-section .survey-form-section-content {
  padding: 0 0 0 20px;
}
.survey-form-wrapper .survey-form-container .survey-form-input {
  width: 100%;
  padding: 13px 22px;
  border-radius: 5px;
  border: 1px solid #dde3ec;
  background: #ffffff;
  font-weight: 300;
  font-size: 16px;
  color: #07074d;
  outline: none;
  resize: none;
}
.survey-form-wrapper .survey-form-container .survey-form-input::placeholder {
  color: #536387;
}
.survey-form-wrapper .survey-form-container .survey-form-input:focus {
  border-color: #6a64f1;
  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.05);
}
.survey-form-wrapper .survey-form-container .survey-form-textarea-container {
  margin: 10px 0 0 0;
}
.survey-form-wrapper .survey-form-container .survey-form-btn {
  text-align: center;
  width: 100%;
  font-size: 16px;
  border-radius: 5px;
  padding: 14px 25px;
  border: none;
  font-weight: 500;
  background-color: #6a64f1;
  color: white;
  cursor: pointer;
  margin-top: 25px;
}
.survey-form-wrapper .survey-form-container .survey-form-btn:disabled {
  opacity: 0.25;
  pointer-events: none;
}
.survey-form-wrapper .survey-form-container .survey-form-btn:hover {
  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.05);
}

.survey-success-message {
  margin: auto;
  top: 50%;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 20px 40px;
  background-color: #c2ffc2;
  border-radius: 4px;
  color: green;
}

.survey-error-message {
  margin: auto;
  top: 50%;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 20px 40px;
  background-color: #f8af8f;
  border-radius: 4px;
  color: #f8762d;
}`, "",{"version":3,"sources":["webpack://./src/views/responses/item/style.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AACF;AACE;EACE,cAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,aAAA;AACJ;AACI;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;AACN;AAEI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AAAN;AAII;EACE,mBAAA;AAFN;AAIM;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AAFR;AAKM;EACE,mBAAA;AAHR;AAQI;EACE,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,YAAA;AANN;AAQM;EACE,cAAA;AANR;AAQM;EACE,qBAAA;EACA,2CAAA;AANR;AAWI;EACE,kBAAA;AATN;AAaI;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AAXN;AAaM;EACE,aAAA;EACA,oBAAA;AAXR;AAcM;EACE,2CAAA;AAZR;;AAoBA;EACE,YAAA;EACA,QAAA;EACA,kBAAA;EACA,SAAA;EACA,gCAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;AAjBF;;AAoBA;EACE,YAAA;EACA,QAAA;EACA,kBAAA;EACA,SAAA;EACA,gCAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;AAjBF","sourcesContent":[".survey-form-wrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 48px;\r\n\r\n  .survey-form-container {\r\n    margin: 0 auto;\r\n    max-width: 570px;\r\n    width: 100%;\r\n    background: white;\r\n    padding: 40px;\r\n\r\n    .survey-form-title {\r\n      font-size: 16px;\r\n      font-weight: 500;\r\n      margin: 0 0 20px 0;\r\n    }\r\n\r\n    .survey-form-description {\r\n      display: flex;\r\n      flex-direction: column;\r\n      gap: 10px;\r\n      font-size: 14px;\r\n      margin: 0 0 40px 0;\r\n      white-space: break-spaces;\r\n      font-weight: 400;\r\n      line-height: 14px;\r\n      font-style: italic;\r\n      color: #3a3f52;\r\n    }\r\n\r\n\r\n    .survey-form-section {\r\n      margin-bottom: 18px;\r\n\r\n      .survey-form-section-label {\r\n        color: #000000;\r\n        font-size: 14px;\r\n        line-height: 24px;\r\n        display: block;\r\n        margin-bottom: 10px;\r\n      }\r\n\r\n      .survey-form-section-content {\r\n        padding: 0 0 0 20px;\r\n      }\r\n    }\r\n\r\n\r\n    .survey-form-input {\r\n      width: 100%;\r\n      padding: 13px 22px;\r\n      border-radius: 5px;\r\n      border: 1px solid #dde3ec;\r\n      background: #ffffff;\r\n      font-weight: 300;\r\n      font-size: 16px;\r\n      color: #07074d;\r\n      outline: none;\r\n      resize: none;\r\n\r\n      &::placeholder {\r\n        color: #536387;\r\n      }\r\n      &:focus {\r\n        border-color: #6a64f1;\r\n        box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.05);\r\n      }\r\n    }\r\n\r\n\r\n    .survey-form-textarea-container {\r\n      margin: 10px 0 0 0;\r\n    }\r\n\r\n\r\n    .survey-form-btn {\r\n      text-align: center;\r\n      width: 100%;\r\n      font-size: 16px;\r\n      border-radius: 5px;\r\n      padding: 14px 25px;\r\n      border: none;\r\n      font-weight: 500;\r\n      background-color: #6a64f1;\r\n      color: white;\r\n      cursor: pointer;\r\n      margin-top: 25px;\r\n\r\n      &:disabled {\r\n        opacity: 0.25;\r\n        pointer-events: none;\r\n      }\r\n\r\n      &:hover {\r\n        box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.05);\r\n      }\r\n    }\r\n\r\n  }\r\n\r\n}\r\n\r\n.survey-success-message {\r\n  margin: auto;\r\n  top: 50%;\r\n  position: absolute;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  padding: 20px 40px;\r\n  background-color: #c2ffc2;\r\n  border-radius: 4px;\r\n  color: green;\r\n}\r\n\r\n.survey-error-message {\r\n  margin: auto;\r\n  top: 50%;\r\n  position: absolute;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  padding: 20px 40px;\r\n  background-color: #f8af8f;\r\n  border-radius: 4px;\r\n  color: #f8762d;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
